import { NoteAnchor } from '../account-notes/account-notes.types';

/** The account page's Pendenzen area. */

export type AccountTodoTag = 'todo' | 'reviewer' | 'client';

/** One Pendenz of the account, ready to show. */
export interface AccountTodoItem {
    id: string;
    text: string;
    tags: AccountTodoTag[];
    /** `null` ⇒ no due date. */
    dueLabel: string | null;
    /** A done Pendenz is never overdue (AC6) — decided by the host. */
    overdue: boolean;
    done: boolean;
    /** `name: null` ⇒ the user is no longer in the organisation's list. */
    assignee: { id: string; name: string | null } | null;
    /** The highlighted spot the Pendenz was created from; `null` ⇒ none. */
    anchor: NoteAnchor | null;
}

export interface AccountTodoPickerOption {
    id: string;
    label: string;
}
